import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "tag-input-root" };
const _hoisted_2 = { class: "tag-input" };
const _hoisted_3 = { class: "tag-content" };
const _hoisted_4 = { class: "input-wrapper" };
const _hoisted_5 = {
    key: 0,
    class: "tag-hash-prefix"
};
const _hoisted_6 = {
    key: 1,
    class: "tag-placeholder"
};
const _hoisted_7 = { class: "tag-menu" };
const _hoisted_8 = ["onMousedown"];
const _hoisted_9 = {
    key: 0,
    class: "tag-chips-below"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = { class: "tagPillText" };
import { ref, computed, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TagInput',
    props: {
        modelValue: {},
        selectableTags: {},
        maxTags: {},
        maxTagLength: {},
        placeholder: {},
        chipsBelow: { type: Boolean }
    },
    emits: ["change", "addedNew"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const maxTags = computed(() => props.maxTags ?? 10);
        const maxTagLength = computed(() => props.maxTagLength ?? 10);
        const selectedTags = ref((props.modelValue ?? []).map(tag => ({ text: tag })));
        const availableTags = ref((props.selectableTags ?? []).map(tag => ({ text: tag })));
        const input = ref(null);
        const errorMessage = ref('');
        const search = ref(null);
        const showMenu = ref(false);
        function isSelected(text) {
            const lower = text.toLowerCase();
            return selectedTags.value.some(t => t.text.toLowerCase() === lower);
        }
        const matchingTags = computed(() => {
            if (!search.value)
                return [];
            const searchLower = search.value.toLowerCase();
            return availableTags.value.filter(tag => tag.text.toLowerCase().includes(searchLower) &&
                !isSelected(tag.text));
        });
        watch(() => props.modelValue, (newValue) => {
            selectedTags.value = (newValue ?? []).map(tag => ({ text: tag }));
        }, { immediate: true });
        function handleBackspace() {
            if (!search.value && selectedTags.value.length > 0) {
                const lastTag = selectedTags.value[selectedTags.value.length - 1];
                remove(lastTag);
            }
        }
        function showMessage(message) {
            errorMessage.value = message;
            setTimeout(() => errorMessage.value = '', 2000);
        }
        function selectTag(tag) {
            if (selectedTags.value.length >= maxTags.value) {
                showMessage(`Maximum ${maxTags.value} tags allowed`);
                return;
            }
            if (!isSelected(tag.text)) {
                selectedTags.value = [...selectedTags.value, tag];
                emit('change', selectedTags.value.map(tag => tag.text));
            }
            search.value = '';
            showMenu.value = false;
            errorMessage.value = '';
        }
        function handleEnter() {
            if (selectedTags.value.length >= maxTags.value) {
                showMessage(`Maximum ${maxTags.value} tags allowed`);
                return;
            }
            if (!search.value)
                return;
            if (search.value.trim().length > maxTagLength.value) {
                showMessage(`Tag must be less than ${maxTagLength.value} characters`);
                return;
            }
            if (search.value.trim()) {
                const searchTrim = search.value.trim();
                if (isSelected(searchTrim)) {
                    showMessage('Tag already added');
                    search.value = '';
                    showMenu.value = false;
                    return;
                }
                const availableMatch = availableTags.value.find(tag => tag.text.toLowerCase() === searchTrim.toLowerCase());
                if (availableMatch) {
                    selectTag(availableMatch);
                }
                else {
                    const newTag = { text: searchTrim };
                    availableTags.value.push(newTag);
                    selectedTags.value = [...selectedTags.value, newTag];
                    emit('addedNew', newTag.text);
                    emit('change', selectedTags.value.map(tag => tag.text));
                    search.value = '';
                    showMenu.value = false;
                }
            }
        }
        function remove(item) {
            const index = selectedTags.value.indexOf(item);
            if (index >= 0) {
                selectedTags.value.splice(index, 1);
                emit('change', selectedTags.value.map(tag => tag.text));
            }
        }
        function onFocus() {
            // iOS doesn't auto-scroll inputs near the bottom into view above the keyboard.
            // Wait for the keyboard to start appearing, then nudge the field into view.
            setTimeout(() => {
                const el = input.value?.$el ?? input.value;
                if (el && typeof el.scrollIntoView === 'function') {
                    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }, 300);
        }
        function onBlur() {
            // iOS "Done" dismisses the keyboard without firing Enter — commit any
            // pending text on blur so the tag isn't lost.
            if (search.value && search.value.trim()) {
                handleEnter();
            }
            setTimeout(() => {
                showMenu.value = false;
            }, 200);
        }
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        (!_ctx.chipsBelow)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(selectedTags.value, (tag) => {
                                return (_openBlock(), _createBlock(_component_v_chip, {
                                    key: tag.text,
                                    closable: "",
                                    class: "tagChip",
                                    "onClick:close": ($event) => (remove(tag))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(tag.text), 1)
                                    ]),
                                    _: 2
                                }, 1032, ["onClick:close"]));
                            }), 128))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, [
                            (_ctx.chipsBelow)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_5, "#"))
                                : _createCommentVNode("", true),
                            (_ctx.placeholder && selectedTags.value.length >= maxTags.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.placeholder), 1))
                                : _createCommentVNode("", true),
                            _createVNode(_component_v_text_field, {
                                ref_key: "input",
                                ref: input,
                                modelValue: search.value,
                                "onUpdate:modelValue": [
                                    _cache[0] || (_cache[0] = ($event) => ((search).value = $event)),
                                    _cache[1] || (_cache[1] = ($event) => (showMenu.value = true))
                                ],
                                variant: "plain",
                                flat: true,
                                density: "compact",
                                "hide-details": "",
                                readonly: selectedTags.value.length >= maxTags.value,
                                "error-messages": errorMessage.value,
                                class: "tag-text-field",
                                onKeydown: [
                                    _withKeys(_withModifiers(handleEnter, ["prevent"]), ["enter"]),
                                    _withKeys(handleBackspace, ["backspace"])
                                ],
                                onFocus: onFocus,
                                onBlur: onBlur
                            }, null, 8, ["modelValue", "readonly", "error-messages", "onKeydown"]),
                            _withDirectives(_createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(matchingTags.value, (tag) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: tag.text,
                                        class: "tag-menu-item",
                                        onMousedown: _withModifiers(($event) => (selectTag(tag)), ["prevent"])
                                    }, _toDisplayString(tag.text), 41, _hoisted_8));
                                }), 128))
                            ], 512), [
                                [_vShow, showMenu.value && matchingTags.value.length > 0]
                            ])
                        ])
                    ])
                ]),
                (_ctx.chipsBelow && selectedTags.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedTags.value, (tag) => {
                            return (_openBlock(), _createElementBlock("button", {
                                key: tag.text,
                                type: "button",
                                class: "tagPill",
                                onClick: ($event) => (remove(tag))
                            }, [
                                _createElementVNode("span", _hoisted_11, [
                                    _cache[2] || (_cache[2] = _createElementVNode("span", { class: "tagPillHash" }, "#", -1)),
                                    _createTextVNode(_toDisplayString(tag.text), 1)
                                ]),
                                _cache[3] || (_cache[3] = _createElementVNode("span", {
                                    class: "tagPillClose",
                                    "aria-label": "Remove tag"
                                }, [
                                    _createElementVNode("svg", {
                                        width: "6",
                                        height: "6",
                                        viewBox: "0 0 6 6",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M0.5 0.5L5.5 5.5M5.5 0.5L0.5 5.5",
                                            stroke: "#413655",
                                            "stroke-linecap": "round"
                                        })
                                    ])
                                ], -1))
                            ], 8, _hoisted_10));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
